import { Id, ReadonlyCollectionRepository } from '../abstraction';
import { ApiResourceLocation } from '../../data-access/types/api.location';
import { toIdString } from '../functions/to-id-string';
import { ApiDataAccess } from '../../data-access/api.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class ReadonlyHttpApiCollectionRepository<TResult, TLoadParams = undefined> implements ReadonlyCollectionRepository<TResult, TLoadParams> {

  protected constructor(protected dataAccess: ApiDataAccess,
                        protected path: string | string[]) { }

  load(params: TLoadParams): Promise<TResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      queryParams: this.getLoadQueryParams(params),
      pathParams: this.getLoadPathParams(params),
    }
    const payload = this.getLoadPayload(params);
    return this.dataAccess.get(location, payload);
  }

  protected getLoadPathParams(params: TLoadParams): Dictionary<unknown> | undefined {
    return undefined;
  }
  protected getLoadQueryParams(params: TLoadParams): Dictionary<unknown> | undefined {
    return undefined;
  }
  protected getLoadPayload(params: TLoadParams): unknown | undefined {
    return undefined;
  }
}
